import { render, staticRenderFns } from "./CriterionRatingWithoutHeader.vue?vue&type=template&id=fa7cd046&scoped=true&"
import script from "./CriterionRatingWithoutHeader.vue?vue&type=script&lang=js&"
export * from "./CriterionRatingWithoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./CriterionRatingWithoutHeader.vue?vue&type=style&index=0&id=fa7cd046&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7cd046",
  null
  
)

export default component.exports